import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments';

@Injectable({ providedIn: 'root' })
export class TimesheetApiService {
  constructor(private http: HttpClient) {}

  public addTimesheet(
    timesheetLabelId: number,
    visitId?: number,
    carMileage?: number,
    warehouseId?: string
  ): Observable<void> {
    const url = `${environment.apiHost}/mobile/timesheet`;
    const createTime = new Date().toLocaleString('sv').replace(' ', 'T');

    const body = {
      timesheetLabelId,
      visitId,
      carMileage,
      createTime,
      carId: warehouseId,
    };

    return this.http.post<void>(url, body);
  }

  public correctVisitDates(
    visitId: number,
    startDateTime: string,
    endDateTime: string
  ): Observable<void> {
    const url = `${environment.apiHost}/mobile/visit/correct-dates`;

    const body = {
      visitId,
      actualStartTime: startDateTime,
      actualEndTime: endDateTime,
    };

    return this.http.post<void>(url, body);
  }
}
